import { paths as brandedThumbsUpPaths } from '../icons/heidi-product-glyphs/generated/thumbs-up';

import type { FeedbackThumbsGeometry } from './feedback-thumbs.types';

// Overshoots the cuff/hand edge to cut the round caps too.
export const BRANDED_THUMB_GEOMETRY: FeedbackThumbsGeometry = {
  grid: 16,
  paths: brandedThumbsUpPaths,
  gap: { x: 4.9, y1: 5.5, y2: 14.8, width: 1 },
};

// lucide-react v1.7.0 `thumbs-up`, vendored: app jest can't load lucide's ESM.
// The `M7 10v12` cuff line is dropped for the gap.
export const LUCIDE_THUMB_GEOMETRY: FeedbackThumbsGeometry = {
  grid: 24,
  paths: [
    'M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z',
  ],
  gap: { x: 7, y1: 8.5, y2: 23.5, width: 1.5 },
};
